<section id="contact" class="section section-2">

    <div class="container">

        <div class="contact-cta">

            <span class="section-badge">
                {{ 'contactSection.badge' | translate }}
            </span>

            <h2 class="section-title">
                {{ 'contactSection.title' | translate }}
            </h2>

            <p class="section-subtitle">
                {{ 'contactSection.subtitle' | translate }}
            </p>

            <a href="https://clockflex.clfx.in/app/book-appointment/loc/1f63f398-3586-4964-d735-08de574647e3/bt/b588e79b-20d8-4cb8-e478-08de574774b8"
                target="_blank" class="btn btn-primary btn-lg contact-demo-btn">

                <i class="fas fa-calendar-check me-2"></i>

                {{ 'contactSection.bookDemo' | translate }}

            </a>

        </div>

        <div class="row g-4 mt-4">

            <div class="col-lg-4">

                <a href="mailto:contact@clockflex.com" class="contact-card text-decoration-none">

                    <div class="contact-icon">
                        <i class="fas fa-envelope"></i>
                    </div>

                    <h5>
                        {{ 'contactSection.emailUs' | translate }}
                    </h5>

                    <p>
                        {{ 'contactSection.email' | translate }}
                    </p>

                </a>

            </div>

            <div class="col-lg-4">

                <a href="https://wa.me/918180974296" target="_blank" class="contact-card text-decoration-none">

                    <div class="contact-icon whatsapp">
                        <i class="fab fa-whatsapp"></i>
                    </div>

                    <h5>
                        {{ 'contactSection.whatsapp' | translate }}
                    </h5>

                    <p>
                        {{ 'contactSection.contactUs' | translate }}
                    </p>

                </a>

            </div>

            <div class="col-lg-4">

                <a [routerLink]="'/contact-us'" class="contact-card text-decoration-none">

                    <div class="contact-icon support">
                        <i class="fas fa-headset"></i>
                    </div>

                    <h5>
                        {{ 'contactSection.contactUs' | translate }}
                    </h5>

                    <p>
                        {{ 'contactSection.writeToUs' | translate }}
                    </p>

                </a>

            </div>

        </div>

    </div>

</section>